// frontend/src/pages/PaymentPage.js
import { useMemo, useState } from "react";

import { useLocation } from "react-router-dom";

import PageContainer from "../components/layout/PageContainer";
import GlassPanel from "../components/layout/GlassPanel";
import BackButton from "../components/layout/BackButton";

import PaymentSummary from "../components/support/PaymentSummary";
import TipSelector from "../components/support/TipSelector";
import PaypalSection from "../components/support/PaypalSection";

export default function PaymentPage() {
  const location = useLocation();

  const packageData = location.state?.packageData;

  const [email, setEmail] = useState("");

  const [tip, setTip] = useState(0);

  const trimmedEmail = useMemo(() => {
    return email.trim().toLowerCase();
  }, [email]);

  const isValidEmail = useMemo(() => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail);
  }, [trimmedEmail]);

  if (!packageData) {
    return (
      <PageContainer>
        <div
          style={{
            width: "100%",
            maxWidth: 760,
          }}
        >
          <GlassPanel>
            <BackButton to="/support" />

            <h1>Missing package</h1>

            <p>Please go back and select a support package again.</p>
          </GlassPanel>
        </div>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <div
        style={{
          width: "100%",
          maxWidth: 800,
        }}
      >
        <BackButton to="/support" />

        <GlassPanel>
          <PaymentSummary packageData={packageData} tip={tip} />

          <div
            style={{
              marginTop: 28,
            }}
          >
            <label
              style={{
                display: "block",
                marginBottom: 10,
                fontSize: 18,
              }}
            >
              Email Address *
            </label>

            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              style={{
                width: "100%",

                padding: 16,

                borderRadius: 12,

                border: isValidEmail
                  ? "2px solid rgba(255,255,255,0.08)"
                  : "2px solid #ff5a5a",

                background: "rgba(255,255,255,0.04)",

                color: "#fff",

                fontSize: 18,
              }}
            />

            {!isValidEmail && email.length > 0 && (
              <div
                style={{
                  marginTop: 10,
                  color: "#ff7b7b",
                  fontSize: 15,
                }}
              >
                Please enter a valid email address.
              </div>
            )}
          </div>

          <TipSelector selectedTip={tip} setSelectedTip={setTip} />

          <PaypalSection
            email={trimmedEmail}
            packageId={packageData.id}
            packageName={packageData.name}
            packagePrice={packageData.price}
            tip={tip}
            disabled={!isValidEmail}
          />
        </GlassPanel>
      </div>
    </PageContainer>
  );
}
